const skinLesionProcessor=(element)=>
{
let assembledElement = ""
let area = true // contols insertion of "area of" text
let lesionType=
    {
    Appearance_suggestive_of_nodular_melanoma: " skin lesion with appearances suggestive of a nodular melanoma",
    Appearance_suspicious_of_squamous_cell_carcinoma: " skin lesion with appearances suggestive of a squamous cell carcinoma",
    Appearances_suspicious_of_basal_cell_carcinoma:" skin lesion with appearances suggestive of a basal cell carcinoma",
    BCC_with_concerning_site_or_size:" skin lesion with appearances suggestive of a basal cell carcinoma",
    Unexplained_bruising: " unexplained bruising",
    Unexplained_petechiae: " petechiae",
    Pruritis: " pruritis"
    }

if (element["symptomGroup"] !== "skinNoSize" && !(element["symptom"] === "Unexplained bruising" && element["Size_(cm)"] === ""))
    {
    assembledElement += " a"
    if (!(element["symptom"] === "Unexplained bruising" && element["Size_(cm)"] !== ""))
        {
        area = false
        }
    }

if (Object.keys(element).includes("Size_(cm)") && element["Size_(cm)"] !== "")
    {
    assembledElement += ` ${element["Size_(cm)"]}cm diameter `
    }

if (area && (element["Site(s)"] !== "" || (Object.keys(element).includes("Size_(cm)") && element["Size_(cm)"] !== "" )))
    {

    assembledElement += ` ${((!Object.keys(element).includes("Size_(cm)") && element["Size_(cm)"] !== "") ? " an" : "")} area of`
    }

let symptomKey = element["symptom"].replaceAll(" ", "_")
assembledElement += ` ${lesionType[symptomKey]}`

if (element["Site(s)"] !== "")
    {
    assembledElement += ` on their ${element["Site(s)"]}`
    }

if (element["Description:"] !== "")
    {
    assembledElement += ` described as ${element["Description:"]}`
    }

if (element["Present_for_several:"] !== "")
{
assembledElement += ` which has been present for several ${(element["Present_for_several:"]).toLowerCase()}`
}


return (assembledElement)
}

export default skinLesionProcessor